customElements.get("social-share") || customElements.define("social-share", class extends HTMLElement {
  constructor() {
    super(), this.handleClick = this.handleClick.bind(this);
  }
  connectedCallback() {
    this.buttonEl = this.querySelector("button"), this.buttonEl && this.buttonEl.addEventListener("click", this.handleClick);
  }
  disconnectedCallback() {
    this.buttonEl && this.buttonEl.removeEventListener("click", this.handleClick);
  }
  getFirstVariantSku() {
    try {
      const t = document.querySelector("main section.shopify-section.section--main-product");
      if (!t) return null;
      const e = t.querySelector('[type="application/json"][data-variant-json]');
      if (!e) return null;
      const n = JSON.parse(e.textContent);
      return n && n.length > 0 ? n[0].sku : null;
    } catch (t) {
      return console.warn("Error fetching SKU for GTM:", t), null;
    }
  }
  handleClick(t) {
    t.preventDefault();
    const e = this.getAttribute("data-url") || window.location.href, n = new URL(e, window.location.origin).origin + window.location.pathname;
    if ("product" === document.body.getAttribute("data-template")) {
      const t = this.getFirstVariantSku();
      let e = "prompt";
      navigator.share ? e = "native_share" : navigator.clipboard && navigator.clipboard.writeText && (e = "copy_to_clipboard"), 
      window.dataLayer = window.dataLayer || [], window.dataLayer.push({
        event: "share",
        method: e,
        content_type: "icon",
        item_id: t || "",
        page_section: "main-content",
        page_type: "pdp"
      });
    }
    const i = {
      title: document.title,
      url: n
    };
    navigator.share ? navigator.share(i).catch(console.error) : navigator.clipboard && navigator.clipboard.writeText ? navigator.clipboard.writeText(n).then(() => alert("Link copied to clipboard!")).catch(t => {
      console.error("Clipboard write failed:", t), prompt("Copy this link:", n);
    }) : prompt("Copy this link:", n);
  }
});